import { useState, useEffect } from 'react';
import {
  Divider,
  Box,
  FormControl,
  InputLabel,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableContainer,
  Select,
  MenuItem,
  CardHeader,
  TextField,
  Container,
  Grid,
  Button,
} from '@mui/material';
import { Imembers } from 'src/Types/module/member/memberTypes';
import { useDebounce } from 'src/hooks/useDebounce';
import { url } from 'src/Helpers/utils/Constant';
import { TableLoader, TableNotFound } from 'src/Utils/TableLoader';
import { useLocation, useSearchParams } from 'react-router-dom';
import CommonMemberTableRow from './CommonMemberTableRow';
import ExcelGenerator from 'src/components/ExcelGenerator/ExcelGenerator';
import PdfGenerator from 'src/components/PdfGenerator/PdfGenerator';
import { HttpClient } from 'src/Helpers/http/http';
import { useAuthContext } from 'src/components/Context/AuthContext/AuthContext';
import ModalsWrapper from 'src/components/Modals/ModalsWrapper';
import CreateMember from '../CreateMember/CreateMember';
import CommonDateRangePicker from 'src/common/CommonDateRangePicker';
import dayjs from 'dayjs';
import { IGetID } from 'src/content/modules/address/district/Address';
import FilterDivisionList from 'src/content/modules/address/district/FilterDivisionList';
import FilterDistrict from 'src/content/modules/address/district/FilterDistrict';
import FilterThanaList from 'src/content/modules/address/district/FilterThanaList';
import FilterAreaList from 'src/content/modules/address/district/FilterAreaList';
import Toaster from 'src/Toaster/Toaster';
import DeleteConfirmation from 'src/Utils/DeleteConfirmation';

const CommonMemberTable = ({ status, title }) => {
  const location = useLocation();
  const { user } = useAuthContext();
  const [allMembers, setAllMembers] = useState<Imembers[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<number>(0);
  const [isDeleteLoading, setIsDeleteLoading] = useState<boolean>(false);
  const [open2, setOpen2] = useState<boolean>(false);
  const [limit, setLimit] = useState<number>(25);
  const [searchCompanyVal, setSearchCompanyVal] = useState<string>('');
  // Modal
  const [open, setOpen] = useState(false);
  // Pagination
  const [searchParams, setSearchParams] = useSearchParams({
    page: '0',
  });
  const page = parseInt(searchParams.get('page') || '0', 10) || 0;
  const [total, setTotal] = useState<number>(0);
  // Search by Time and Zone
  const searchQuery = useDebounce(searchCompanyVal, 1000);
  const [dateRange, setDateRange] = useState<{
    start_date: string;
    end_date: string;
  }>({
    start_date: '',
    end_date: dayjs().format('YYYY-MM-DD'),
  });
  const [zone, setZone] = useState<number>(0);
  const [checked, setChecked] = useState<IGetID>({
    division: null,
    district: null,
    thana: null,
    area: null,
  });
  // /member-list/cceehkr - list;
  useEffect(() => {
    setIsLoading(true);
    (async function () {
      try {
        if (!searchQuery) {
          let uri = `${url}/api/atab/user-member/get/all/by/date/zone/status/for-admin?status=${status}&division_id=${checked?.division?.division_id || ''}&district_id=${checked?.district?.district_id || ''}&area_id=${checked?.area?.area_id || ''}&thana_id=${checked?.thana?.thana_id || ''}&`;
          if (dateRange.start_date && dateRange.end_date) {
            uri += `from_date=${dateRange.start_date}&to_date=${dateRange.end_date}&`;
          }
          if (zone > 0) {
            uri += `zone=${zone}&`;
          }
          if (location.pathname === '/member-list/checker-list') {
            uri += `admin_id=${user?.user_admin_id}&`;
          }
          if (page >= 0) {
            uri += `skip=${limit * page}&limit=${limit}`;
          }
          const data: any = await HttpClient.get(uri);

          if (data.success) {
            setAllMembers(data.data);
            setTotal(data.total);
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        } else {
          const data: any = await HttpClient.get(
            `${url}/api/atab/user-member/get/all/by/date/zone/status/for-admin?status=${status}&company_name=${encodeURIComponent(searchQuery)}&division_id=${checked?.division?.division_id}&skip=0&limit=50`
            //`${url}/api/atab/user-member/search-member/by-company/${searchQuery}?status=${status}&zone=${zone}`
          );
          if (data.success) {
            setAllMembers(data.data);
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        }
      } catch (error) {
        setIsLoading(false);
      }
    })();
  }, [
    searchQuery,
    page,
    limit,
    dateRange,
    zone,
    checked.division,
    checked.district,
    checked.area,
    checked.thana,
  ]);

  const getDownloadData = async () => {
    try {
      let uri = `${url}/api/atab/user-member/download/member/data/for-admin?type=excel&status=${status}&division_id=${checked?.division?.division_id || ''}&district_id=${checked?.district?.district_id || ''}&area_id=${checked?.area?.area_id || ''}&thana_id=${checked?.thana?.thana_id || ''}&`;
      if (dateRange.start_date && dateRange.end_date) {
        uri += `from_date=${dateRange.start_date}&to_date=${dateRange.end_date}&`;
      }
      if (zone > 0) {
        uri += `zone=${zone}&`;
      }

      const data: any = await HttpClient.get(uri);
      if (data.success) {
        return data;
      } else {
        return [];
      }
    } catch (err) {
      console.error('Error fetching download data:', err);
      return [];
    }
  };

  const handleDelete = (id: number) => {
    (async function () {
      try {
        setIsDeleteLoading(true);
        const uri = `${url}/api/atab/user-member/delete/member/${id}`;
        const data = await HttpClient.delete(uri);
        if (data) {
          const filterData = allMembers.filter(
            (item) => item.user_member_id !== id
          );
          setAllMembers(filterData);
          Toaster().fire({
            icon: 'success',
            title: 'Deleted successfully!',
          });

          setIsDeleteLoading(false);
          setOpen2(false);
        }
      } catch (error) {
        setIsDeleteLoading(false);
      }
    })();
  };
  return (
    <>
      <Container maxWidth='xl'>
        <Grid
          container
          direction='row'
          justifyContent='center'
          alignItems='stretch'
          spacing={3}
        >
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <Grid
                container
                spacing={2}
                alignItems='center'
                justifyContent='flex-end'
              >
                <Grid item xs={12} md={6} lg={4}>
                  <CommonDateRangePicker
                    setDateRange={setDateRange}
                    dateRange={dateRange}
                  />
                </Grid>

                <Grid item xs={12} md={3} lg={2}>
                  <FormControl fullWidth size='small'>
                    <InputLabel id='zone-select-label'>Select zone</InputLabel>
                    <Select
                      labelId='zone-select-label'
                      value={zone}
                      onChange={(e: any) => setZone(e.target.value)}
                    >
                      <MenuItem value={0}>All</MenuItem>
                      <MenuItem value={1}>Dhaka</MenuItem>
                      <MenuItem value={2}>Chittagong</MenuItem>
                      <MenuItem value={3}>Sylhet</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3} lg={8}>
                  <Grid container justifyContent='flex-end' alignItems='center'>
                    <Grid item xs={12} md={6} lg={3}>
                      <FilterDivisionList
                        checked={checked}
                        setChecked={setChecked}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                      <FilterDistrict
                        checked={checked}
                        setChecked={setChecked}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                      <FilterThanaList
                        checked={checked}
                        setChecked={setChecked}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                      <FilterAreaList
                        checked={checked}
                        setChecked={setChecked}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Grid item xs={12} pb={2}>
            <Card>
              <CardHeader
                action={
                  <Box display='flex' justifyContent='space-between' gap={1}>
                    <TextField
                      id='outlined-basic'
                      label='Search Company'
                      variant='outlined'
                      size='small'
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setSearchCompanyVal(e.target.value)
                      }
                    />
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <ExcelGenerator getDownloadData={getDownloadData} />
                      <PdfGenerator getDownloadData={getDownloadData} />
                      {/* <Button
                        onClick={() => {
                          generatePDF(componentRef, {
                            filename: `member_list.pdf`,
                            // page: {
                            //   margin: Margin.SMALL,
                            //   format: "letter",
                            //   orientation: "landscape",
                            // },
                          });

                          getDownloadData2();
                        }}
                        variant="outlined"
                        size="small"
                      >
                        Download pdf
                      </Button> */}
                    </Box>

                    {user?.user_admin_role === 'Super Admin' ||
                    user?.user_admin_role === 'Admin' ? (
                      <Button onClick={() => setOpen(true)} variant='contained'>
                        Create Member
                      </Button>
                    ) : (
                      ''
                    )}
                  </Box>
                }
                title={`${title} (${total})`}
              />
              <Divider />

              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>SL.</TableCell>
                      <TableCell>ID</TableCell>
                      <TableCell>Company Name</TableCell>
                      <TableCell>Owner name</TableCell>
                      <TableCell>Phone</TableCell>
                      <TableCell>Zone</TableCell>
                      {user?.user_admin_role !== 'Application Inspection' && (
                        <TableCell>Inspect by</TableCell>
                      )}

                      <TableCell>Status</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {isLoading ? (
                      <TableLoader />
                    ) : allMembers.length ? (
                      <>
                        {allMembers?.map((allMembers: Imembers, index) => {
                          return (
                            <>
                              <CommonMemberTableRow
                                key={index}
                                allMembers={allMembers}
                                index={page * limit + index}
                                open2={open2}
                                setOpen2={setOpen2}
                                status={status}
                                handleDelete={(id) => {
                                  setDeleteId(id);
                                }}
                              />
                            </>
                          );
                        })}
                      </>
                    ) : (
                      <TableNotFound />
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box p={2}>
                <TablePagination
                  component='div'
                  count={total}
                  onPageChange={(_event: any, newPage: number) => {
                    searchParams.set('page', newPage.toString());
                    setSearchParams(searchParams);
                  }}
                  onRowsPerPageChange={(event) => {
                    setLimit(parseInt(event.target.value));
                    searchParams.set('page', '0');
                    setSearchParams(searchParams);
                  }}
                  page={page}
                  rowsPerPage={limit}
                  rowsPerPageOptions={[25, 50, 75, 100]}
                />
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* create member */}
      <ModalsWrapper
        modalData={{ title: 'Create Member' }}
        setShowModal={setOpen}
        showModal={open}
      >
        <CreateMember setAllMembers={setAllMembers} handleClose={setOpen} />
      </ModalsWrapper>

      <DeleteConfirmation
        open={open2}
        handleClose={() => setOpen2(false)}
        text='Want to delete this member?'
        handleDeleteFun={() => handleDelete(deleteId)}
        loading={isDeleteLoading}
      />
    </>
  );
};

export default CommonMemberTable;
